module.exports = __webpack_public_path__ + "a81fd8618aa2e5006f2c49867fbb9239.svg";